import React from 'react'
import cx from 'classnames'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { DropdownAnchor } from './common/DropdownAnchor/DropdownAnchor'
import { DropdownMenu } from './common/DropdownMenu/DropdownMenu'

export const ActionsDropdown = ({
  actions,
  anchorClassName = undefined,
  menuClassName = undefined,
  isDisabled = false,
  size,
}) => (
  <Dropdown hasArrow>
    <DropdownAnchor
      ariaLabel="actions"
      className={cx({ [anchorClassName]: Boolean(anchorClassName) })}
      {...{ size, isDisabled }}
    />
    <DropdownMenu
      className={cx({ [menuClassName]: Boolean(menuClassName) })}
      {...{ actions }}
    />
  </Dropdown>
)
